import { DateFormate } from "@/util/params";
import { Space, Collapse } from "antd";
import { FC } from "react";
import { RefranceTransactionData } from "../refrance-transaction";
import { AttachmentList } from "../attachmentList";
import style from './style.module.scss'

type complaintdetailProps = {
    complaint: any;
    complaintFieldMap: any;
    dateFormate: any;
};
export const ComplaintDetailData: FC<complaintdetailProps> = (props) => {
    const complaints = Array.isArray(props.complaint)
        ? props.complaint
        : [props.complaint];

    return (
        <div className={style.complaintWrapper}>
            {complaints.map((complaint: any, index: number) => (

                <div key={index}>
                    <Space direction="vertical">

                        <div style={{ fontWeight: "500", paddingTop: "10px" }}>
                            Chargebacks
                        </div>

                        <Collapse
                            collapsible="header"
                            style={{ width: "580px" }}
                            defaultActiveKey={[]}
                            items={[
                                {
                                    key: index,
                                    label: (
                                        <div className={style.badge}>
                                            <span style={{ color: "#1F6EE2" }}>
                                                {complaint?.complaint_id}
                                            </span>
                                            <span
                                                style={{
                                                    background: "#E6F7FF",
                                                    padding: 5,
                                                    border: "1px solid #91D5FF",
                                                    borderRadius: 4,
                                                    color: "#1890FF",
                                                    fontSize: 10,
                                                    textTransform: "capitalize"
                                                }}
                                            >
                                                {complaint?.status}
                                            </span>
                                            <span>{complaint.dispute_amount?.amount + " INR"}</span>
                                            <span>{DateFormate(complaint.created_date)}</span>

                                        </div>
                                    ),
                                    children: (
                                        <Space direction="vertical" style={{ width: "100%" }}>
                                            <div className={style.comp}>
                                                {Object.entries(props.complaintFieldMap).map(([key, label]: any) => {
                                                    const value = complaint[key];
                                                    let displayValue = "-";

                                                    if (key === "created_date") {
                                                        displayValue = props.dateFormate(value);
                                                    } else if (key === "dispute_amount" && value) {
                                                        displayValue = `${value.amount} ${value.currency_symbol}`;
                                                    } else if (key === "reason_code" && value) {
                                                        displayValue = value.description;
                                                    } else if (value !== undefined && value !== null) {
                                                        displayValue = String(value);
                                                    }

                                                    return (
                                                        <div key={key} className={style.compitem}>
                                                            <span className={style.comptitle}>{label}</span>
                                                            <p style={{ textTransform: "capitalize" }}>{displayValue}</p>
                                                        </div>
                                                    );
                                                })}
                                            </div>


                                            <div className={style.compDescription}>
                                                <span className={style.comptitle}>Chargeback Description</span>
                                                <p>{complaint?.complaint_description || "-"}</p>
                                            </div>
                                            {
                                                complaint.reference_transaction && (
                                                    <div style={{ borderTop: "1px solid #D9D9D9" }}>
                                                        <div style={{ paddingTop: "20px" }}>
                                                            <RefranceTransactionData
                                                                referenceData={complaint.reference_transaction}
                                                                title={"Reference Transaction Information"}
                                                            />
                                                        </div>

                                                    </div>
                                                )

                                            }


                                            <AttachmentList complaintId={complaint?.complaint_id} />

                                        </Space>
                                    ),
                                }
                            ]}
                        />
                        {/* Reference Transaction */}
                        {/* {complaint?.reference_transaction && (
                            <Space direction="vertical" style={{ paddingBottom: "1rem" }}>
                                <div style={{ paddingTop: "10px", fontWeight: "500" }}>
                                    Reference Transaction
                                </div>

                                <Collapse
                                    collapsible="header"
                                    style={{ width: "580px" }}
                                    defaultActiveKey={[]}
                                    items={[
                                        {
                                            key: index,
                                            label: (
                                                <div style={{
                                                    overflowWrap: "break-word",
                                                    maxWidth: "400px",
                                                    textTransform: "capitalize"
                                                }}>
                                                    {complaint.reason_code?.description}
                                                </div>
                                            ),
                                            children: (
                                                <RefranceTransactionData
                                                    referenceData={complaint.reference_transaction}
                                                    title={complaint.reason_code?.description}
                                                />
                                            )
                                        }
                                    ]}
                                />
                            </Space>
                        )} */}

                    </Space>
                </div>
            ))}
        </div>
    );
};
